import { UPDATE_SELECTED_DATE } from '../actions/dashboard';
import { getWindowSizeValues, UPDATED_WINDOW_SIZE } from '../actions/windowSize';

const initialState = {
	screenHeight: null,
	screenWidth: null,
	sizeMobile: null,
	sizeTablet: null,
	sizeDesktop: null,
	sizeLargeDesktop: null,
	...getWindowSizeValues() // Overrides the other values, screenHeight etc etc, we just set the others above this for "documentation" purposes
};
export default (state = initialState, action) => {
	switch(action.type) {
		case UPDATED_WINDOW_SIZE: {

			return {
				...state,
				...action.payload,
			};
		}
		default: {
			return state;
		}
	}
};

